export class PromoCarousel {

    constructor() {
        console.log('loaded');
        if ($(".component-promo-carousel").length > 0) {
            this.properties();
            this.init();
        }
    }

    properties() {
        this.mobileSize = 768;
        this.isMobile = window.innerWidth < this.mobileSize;
        this.sliderSelector = ".component-promo-carousel";
        this.slidesToShow = 1.2;
        this.slidesToScroll = 1;
        this.initialSlide = 0;
    }

    init() {
        this.registerResizeHandler();
        this.loadSlick();
    }

    registerResizeHandler() {
        window.onresize = this.onResize.bind(this);
    }

    onResize() {
        $(this.sliderSelector)[0].slick.refresh();
    }

    loadSlick() {

        $(this.sliderSelector).slick({
            dots: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            initialSlide: 0,
            arrows: true,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 1100,
                    settings: {
                        dots: true,
                        infinite: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true,
                        initialSlide: 0,
                        arrows: true
                    }
                }
            ]
        });

    }



}